import React, { useState } from "react";
import { HelpCircle, X, Phone, Mail } from "lucide-react";

const HelpWidget = () => {
  const [open, setOpen] = useState(false);

  return (
    <div className="fixed bottom-6 right-6 z-[80] flex flex-col items-end gap-3">
      {open && (
        <div className="w-72 bg-white rounded-lg shadow-2xl border border-slate-200 p-4 animate-in fade-in slide-in-from-bottom-2">
          <div className="flex items-center justify-between mb-2">
            <h6 className="font-semibold text-slate-800">Need Help?</h6>
            <button
              onClick={() => setOpen(false)}
              className="text-slate-400 hover:text-slate-700 transition-colors"
              aria-label="close"
            >
              <X size={18} />
            </button>
          </div>
          <p className="text-sm text-slate-600 mb-3">
            Talk to our customer care team.
          </p>
          <div className="space-y-2 mb-3">
            <a
              href="tel:+919988446478"
              className="flex items-center gap-2 text-sm text-slate-700 hover:text-[#14B8A6]"
            >
              <Phone size={14} className="text-[#14B8A6]" /> +91 99884 46478
            </a>
            <a
              href="mailto:support@dotmedy.com"
              className="flex items-center gap-2 text-sm text-slate-700 hover:text-[#14B8A6]"
            >
              <Mail size={14} className="text-[#14B8A6]" /> support@dotmedy.com
            </a>
          </div>
          <a
            href="mailto:support@dotmedy.com"
            className="block text-center bg-[#14B8A6] hover:bg-[#0F8A7D] text-white text-[13px] font-semibold uppercase tracking-wide px-4 py-2.5 rounded-sm transition-colors"
          >
            Contact Support
          </a>
        </div>
      )}

      <button
        onClick={() => setOpen((v) => !v)}
        className="flex items-center gap-2 bg-[#14B8A6] hover:bg-[#0F8A7D] text-white px-4 py-2.5 rounded-full shadow-lg transition-colors"
      >
        <HelpCircle size={18} />
        <span className="text-sm font-medium">Help</span>
      </button>
    </div>
  );
};

export default HelpWidget;
